module.exports = __webpack_public_path__ + "img/gaia.91a38c68.jpg";